import moment from "moment";

export const timeFromNow = (time, serverTime) => {
    if (time === undefined || time === '0001-01-01T00:00:00Z' || time === null) return ''
    return moment(moment.utc(time).format('DD/MM/YYYY HH:mm'), 'DD/MM/YYYY HH:mm').from(serverTime);
}

export const timeFrom = (time, timeFrom) => {
    if (time === undefined || time === '0001-01-01T00:00:00Z' || time === null) return ''
    return moment(time).from(timeFrom).replace('yang lalu', '');
}

export const targetResponseTime = minute => {
    if (minute > 0) {
        if (minute >= 60) {
            if (minute >= 1440) {
                return ` | Jatuh tempo respon ${Math.floor(minute / 1440)} hari`
            }

            return ` | Jatuh tempo respon ${Math.floor(minute / 60)} jam ${minute % 60} menit`
        }

        return ` | Jatuh tempo respon ${minute} menit`
    }

    if (minute < 0) {
        let absMinute = Math.abs(minute);
        if (absMinute >= 60) {
            if (absMinute >= 1440) {
                return ` | Respon telat ${Math.floor(absMinute / 1440)} hari yang lalu`
            }

            return ` | Respon telat ${Math.floor(absMinute / 60)} jam ${absMinute % 60} menit yang lalu`
        }

        return ` | Respon telat ${absMinute} menit`
    }

    if (minute === 0) {
        return ` | Jatuh tempo respon beberapa detik`
    }
}

export const targetResolutionTime = minute => {
    if (minute > 0) {
        if (minute >= 60) {
            if (minute >= 1440) {
                return ` | Jatuh tempo resolusi ${Math.floor(minute / 1440)} hari`
            }

            return ` | Jatuh tempo resolusi ${Math.floor(minute / 60)} jam ${minute % 60} menit`
        }

        return ` | Jatuh tempo resolusi ${minute} menit`
    }

    if (minute < 0) {
        let absMinute = Math.abs(minute);
        if (absMinute >= 60) {
            if (absMinute >= 1440) {
                return ` | Resolusi telat ${Math.floor(absMinute / 1440)} hari yang lalu`
            }

            return ` | Resolusi telat ${Math.floor(absMinute / 60)} jam ${absMinute % 60} menit yang lalu`
        }

        return ` | Resolusi telat ${absMinute} menit`
    }
}

export const dashboardAverageTime = minute => {
    if (minute > 0) {
        if (minute >= 60) {
            if (minute >= 1440) {
                return `${Math.floor(minute / 1440)} hari`
            }

            return `${Math.floor(minute / 60)}J ${minute % 60}M`
        }

        return `${minute}M`
    }

    if (minute === 0) {
        return `0`;
    }
}

export function secondsToTime(currentSeconds = 0) {
    const sec = parseInt(currentSeconds, 10);
    const hours = Math.floor(sec / 3600);
    const minutes = Math.floor((sec - (hours * 3600)) / 60);
    const seconds = sec - (hours * 3600) - (minutes * 60);

    let strHours = hours
    let strMinutes = minutes
    let strSeconds = seconds

    if (hours < 10) {
        strHours = "0" + hours;
    }

    if (minutes < 10) {
        strMinutes = "0" + minutes
    }

    if (seconds < 10) {
        strSeconds = "0" + seconds;
    }

    if (hours === 0) {
        return strMinutes + ':' + strSeconds;
    }

    return strHours + ':' + strMinutes + ':' + strSeconds;
}

/**
 * @returns {string}
 */
export function timeNow() {
    return formatTime(new Date())
}

/**
 * @param {Date} date 
 * @returns {string}
 */
export function formatTime(date) {
    let years = date.getFullYear()
    let months = date.getMonth() + 1
    let days = date.getDate()

    let hours = date.getHours()
    let minutes = date.getMinutes()
    let seconds = date.getSeconds()

    if (months < 10) {
        months = '0' + months
    }

    if (days < 10) {
        days = '0' + days
    }

    if (hours < 10) {
        hours = '0' + hours
    }

    if (minutes < 10) {
        minutes = '0' + minutes
    }

    if (seconds < 10) {
        seconds = '0' + seconds
    }

    return `${years}-${months}-${days}T${hours}:${minutes}:${seconds}Z`
}